import http from 'hub-http/clients/apiClient';
import Raven from 'raven-js';
export const submitInteraction = upgradeKey => http.post(`/upgrade-management-service/v1/interactions/${upgradeKey}`).catch(error => {
  // 403s are caused by Impersonators, so we don't want to log them.
  // Docs: https://product.hubteam.com/docs/auth-docs/guides/backend-services-auth/impersonation.html#key-concepts
  if ((error === null || error === void 0 ? void 0 : error.status) === 403) return Promise.resolve();
  Raven.captureException(Error('Failed to submit interaction', {
    cause: error
  }), {
    extra: {
      message: error.message,
      status: error.status,
      upgradeKey
    }
  });
});